var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"column":""}},[_c('v-card',[_c('v-card-title',[_vm._v("Appearence")]),_c('v-card-text',[_c('v-checkbox',{attrs:{"label":"Dark theme"},model:{value:(_vm.isDarkLocal),callback:function ($$v) {_vm.isDarkLocal=$$v},expression:"isDarkLocal"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }